import { sendWarning } from '@components/Noti';
import { generateCLayerId } from '@modules/componentLayer';
import {
  $categoryMapApi,
  $sceneMap,
  $sceneMapApi,
  $selectedPath,
} from '@stores/dataStores';
import { $editingHotspot } from '@stores/editingHotspotStores';
import type { GeneralID } from '@types';
import { getMaxSceneNumber } from '@utils/getMaxSceneNumber';
import { createEvent, sample } from 'effector';
import { current } from 'immer';
import { nanoid } from 'nanoid';

const duplicateScene = createEvent<{
  sceneId: GeneralID;
  categoryId?: number;
}>();

sample({
  source: {
    selectedPath: $selectedPath,
    sceneMap: $sceneMap,
    editingHotspot: $editingHotspot,
  },
  clock: duplicateScene,
  fn: (source, clock) => ({ ...source, ...clock }),
}).watch(({ selectedPath, sceneMap, sceneId, editingHotspot, categoryId }) => {
  const { maxScene } = getMaxSceneNumber();
  if (sceneMap.size >= maxScene) {
    sendWarning(`复制场景失败，当前作品场景数已达上限${maxScene}个`);
    return;
  }
  const id = nanoid();
  const cId =
    categoryId ??
    selectedPath.categoryPath[selectedPath.categoryPath.length - 1];

  // 图层新旧id映射
  const idMap = new Map<string, string>();
  sceneMap.get(sceneId)!.config.components?.forEach((x) => {
    const newId = generateCLayerId();
    idMap.set(x.id, newId);
  });

  $sceneMapApi.update((draft) => {
    console.log('1', 'color: #af0bab', current(draft.get(sceneId)));
    const newScene = { ...draft.get(sceneId)!, id };
    if (sceneId === selectedPath.id && editingHotspot?.isNew) {
      // 复制场景时，去除正在编辑的新热点
      newScene.hotspot = newScene.hotspot!.filter(
        (x) => x.id !== editingHotspot.hotspot.id
      );
    }
    // 更新图层ID, 图层控制里的图层id
    newScene.config.components?.forEach((x) => {
      x.id = idMap.get(x.id) ?? x.id;
      x.layerControl.data.forEach((y) => {
        y.id = idMap.get(y.id) ?? y.id;
      });
    });
    // 更新热点图层控制里的图层id
    newScene.hotspot?.forEach((x) => {
      x.extendAction?.layers?.forEach((y) => {
        y.id = idMap.get(y.id) ?? y.id;
      });
    });

    draft.set(id, newScene);
    console.log('2', 'color: #af0bab', newScene);
  });
  $categoryMapApi.update((draft) => {
    const { sceneIds } = draft.get(cId)!;
    const index = sceneIds.findIndex((x) => x === sceneId);
    sceneIds.splice(index + 1, 0, id);
  });
});

export default duplicateScene;
